// extracted by mini-css-extract-plugin
module.exports = {"password":"share-base-form_password_3r4-9"};